import { render, staticRenderFns } from "./AttributeTemplates.vue?vue&type=template&id=3941c1ff&"
import script from "./AttributeTemplates.vue?vue&type=script&lang=js&"
export * from "./AttributeTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTemplates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports